import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import CTASection from "../components/CTASection";

export default function LocationsPage() {
  const [cities, setCities] = useState([]);

  useEffect(() => {
    document.title = "Service Areas | Pool Guru Treasure Coast";
    api.get("/cities").then((r) => setCities(r.data)).catch(() => {});
  }, []);

  const byRegion = cities.reduce((acc, c) => {
    const region = c.parent ? cities.find((x) => x.slug === c.parent)?.name || c.region : c.region;
    acc[region] = acc[region] || [];
    acc[region].push(c);
    return acc;
  }, {});

  return (
    <div data-testid="locations-page">
      <section className="relative bg-gradient-to-b from-pink-50/50 to-white py-20">
        <div className="section-container">
          <div className="overline mb-3">Service Areas</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 max-w-4xl">
            Pool cleaning across the <span className="text-brand-pink">Treasure Coast</span>.
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl">
            From Port St. Lucie to Stuart, we bring dependable weekly pool service to communities
            across St. Lucie and Martin counties. Select your location below.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="section-container space-y-12">
          {Object.entries(byRegion).map(([region, list]) => (
            <div key={region}>
              <h2 className="text-2xl sm:text-3xl font-extrabold mb-6 flex items-center gap-3">
                <MapPin className="w-6 h-6 text-brand-pink" /> {region}
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {list.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/pool-service-${c.slug}`}
                    className="group bg-white border border-slate-200 rounded-2xl overflow-hidden hover:border-brand-pink hover:-translate-y-0.5 hover:shadow-lg transition-all"
                    data-testid={`location-card-${c.slug}`}
                  >
                    {c.hero_image && (
                      <div className="aspect-[16/10] overflow-hidden">
                        <img src={c.hero_image} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                      </div>
                    )}
                    <div className="p-6">
                      <div className="flex items-start justify-between mb-2">
                        <h3 className="text-lg font-bold text-brand-navy group-hover:text-brand-pink transition-colors">
                          {c.name}
                        </h3>
                        <ArrowRight className="w-4 h-4 text-slate-400 group-hover:text-brand-pink group-hover:translate-x-1 transition-all" />
                      </div>
                      <p className="text-sm text-slate-500 line-clamp-2">
                        {c.meta_description}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
